import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PersonalInfoService } from '../../../shared/services/personal-info.service';

@Component({
  selector: 'app-personal-information',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './personal-information.component.html',
  styleUrl: './personal-information.component.scss',
})
export class PersonalInformationComponent implements OnInit {
  personalInfoForm!: FormGroup;
  isSubmitted: boolean = false;
  errMsg: String = '';

  constructor(
    private _router: Router,
    private _personalInfo: PersonalInfoService,
  ) {}

  ngOnInit(): void {
    //Forget username form initialization
    this.personalInfoForm = new FormGroup({
      addressLine1: new FormControl('', [Validators.required]),
      addressLine2: new FormControl(''),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      zipCode: new FormControl('', [Validators.required]),
      emailAddress: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', [
        Validators.required,
        Validators.minLength(10), // Minimum 10 digits
        Validators.maxLength(10), // Maximum 10 digits
      ]),
      communicationType: new FormControl('', [Validators.required]),
    });
  }

  // convenience getter for easy access to form fields
  get form() {
    return this.personalInfoForm.controls;
  }

  // Navigate to sign-in page
  backToSignin() {
    this._router.navigate(['/login']);
  }

  // Submit the form
  onSubmit() {
    this.isSubmitted = true;
    if (this.personalInfoForm.valid) {
      const emailAddr = this.personalInfoForm.value.emailAddress;
      const communicationTypeValue = this.personalInfoForm.value.communicationType === 'Sms' ? 0 : 1;
      const payload: any = {
        requestingSystem: 'FinPro',
        phoneNumber: this.personalInfoForm.value.phone,
        email: emailAddr,
        address: {
          addressLine1: this.personalInfoForm.value.addressLine1,
          addressLine2: this.personalInfoForm.value.addressLine2,
          city: this.personalInfoForm.value.city,
          state: this.personalInfoForm.value.state,
          zipCode: this.personalInfoForm.value.zipCode,
          country: 'USA',
        },
        communicationType: communicationTypeValue,
      };

      this.disableEnableSubmitButton(true); // Disable the button

      this._personalInfo.PersonalInfo(payload).subscribe(
        (response) => {
          if (response.action === 'PassCode') {
            const pinEntry = { res: response };
            this._router.navigate(['/user-profile/pin-entry'], { state: { pinEntry } });
          } else if (response.action === 'SecurityQuestion') {
            const securityQA = { qA: response };
            this._router.navigate(['/user-profile/security-question'], { state: { securityQA } });
          } else {
            this._router.navigate(['/user-profile/call-us']);
            this.errMsg = 'Invalid email address';
          }
        },
        (error) => {
          this.disableEnableSubmitButton(false); // Enable the button after response
          this.errMsg = error.error.message;
        },
        () => {
          this.disableEnableSubmitButton(false); // Enable the button after response
        },
      );
    } else {
      setTimeout(() => {
        const firstInvalidControl = document.querySelector('.is-required.ng-invalid');
        if (firstInvalidControl) {
          (firstInvalidControl as HTMLElement).focus();
        }
      }, 100);
    }
  }

  disableEnableSubmitButton(isEnable: boolean) {
    const submitButton = document.getElementById('submitBtn') as HTMLButtonElement;
    if (isEnable && submitButton) {
      submitButton.disabled = true; // Disable the button
      submitButton.style.cursor = 'not-allowed'; // Change cursor to indicate disabled state
      submitButton.style.opacity = '0.6'; // Reduce opacity to visually indicate disabled state
      submitButton.style.pointerEvents = 'none'; // Disable hover effect
    } else {
      // Enable the button after response
      submitButton.disabled = false; // Enable the button
      submitButton.style.cursor = 'pointer'; // Change cursor back to pointer
      submitButton.style.pointerEvents = 'auto'; // Re-enable hover effect
      submitButton.style.opacity = '1'; // Reduce opacity to visually indicate disabled state
    }
  }
}
